import React from 'react'
import Filters from 'Features/Filters'

const defaultFilters = {
  customers: 'All',
  locations: 'All',
  functions: 'All',
  powerState: 'All',
  managedByCalligo: 'All',
  billable: 'All',
  assetTypes: 'All',
  clusters: 'All',
  ownership: 'All',
  customerStatus: 'All'
}

const ReportFilters = ({ filters, changeFilters, filterOptions }) => (
  <Filters {...{ filters, onChange: changeFilters, shareable: true, defaultFilters }}>
    <div className="row mb-3">
      <div className="col"><Filters.Select {...{ filterName: 'locations',  ...filterOptions.locations }} /></div>
      <div className="col"><Filters.Select {...{ filterName: 'customers',  ...filterOptions.customers }} /></div>
      <div className="col"><Filters.Select {...{ filterName: 'customerStatus',  ...filterOptions.customerStatus }} /></div>
      <div className="col"><Filters.Select {...{ filterName: 'powerState', ...filterOptions.powerState }} /></div>
    </div>

    <div className="row mb-3">
      <div className="col"><Filters.Select {...{ filterName: 'billable',   ...filterOptions.billable }} /></div>
      <div className="col"><Filters.Select {...{ filterName: 'assetTypes', ...filterOptions.assetTypes }} /></div>
      <div className="col"><Filters.Select {...{ filterName: 'clusters',         ...filterOptions.clusters }} /></div>
      <div className="col"><Filters.Select {...{ filterName: 'functions',        ...filterOptions.functions }} /></div>
    </div>

    <div className="row">
      <div className="col"><Filters.Select {...{ filterName: 'ownership',        ...filterOptions.ownership }} /></div>
      <div className="col"><Filters.Select {...{ filterName: 'managedByCalligo', ...filterOptions.managedByCalligo, label: 'Calligo Management VMs' }} /></div>
    </div>
  </Filters>
)

export { ReportFilters, defaultFilters }
